import { isVisible } from '.'

// Copied Implementation from Jquery
// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/css/hiddenVisibleSelectors.js#L5-L10
export const isHidden = e => !isVisible(e)
